import { Box, Typography } from '@mui/material'
import { Trans } from '@lingui/macro'
import { RISK_MAP_LEGEND_GRADIENT } from './roadRiskMapLayer'
import { formatRiskScore } from '../../shared/constants/risk-map'

/**
 * Compact gradient legend for the road risk map layer.
 */
export default function RoadRiskMapLegend({ maxRiskScore = 0, visible }) {
  if (!visible) return null

  const maxLabel = Number.isFinite(maxRiskScore)
    ? formatRiskScore(maxRiskScore)
    : formatRiskScore(0)

  return (
    <Box
      sx={{
        position: 'absolute',
        bottom: 24,
        left: 12,
        zIndex: 2,
        bgcolor: 'background.paper',
        borderRadius: 1,
        boxShadow: 2,
        px: 1.5,
        py: 1,
        minWidth: 140,
        pointerEvents: 'none',
      }}
    >
      <Typography variant="caption" sx={{ fontWeight: 600, display: 'block', mb: 0.5 }}>
        <Trans>Road risk / km</Trans>
      </Typography>
      <Box
        sx={{
          height: 8,
          borderRadius: 1,
          background: RISK_MAP_LEGEND_GRADIENT,
          mb: 0.5,
        }}
      />
      <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
        <Typography variant="caption" color="text.secondary">0</Typography>
        <Typography variant="caption" color="text.secondary">{maxLabel}</Typography>
      </Box>
    </Box>
  )
}
